// extracted by mini-css-extract-plugin
module.exports = {"listItem":"ListItem_listItem__-nVLS","detailTitle":"ListItem_detailTitle__2kaoO","detailValue":"ListItem_detailValue__bu0mm"};